import { updateFontStatusAction as updateFontStatusOperation } from 'editor/src/store/fonts/slice';

export default updateFontStatusOperation;
